<div class="login-container">
  <div class="login-model">
    <img class="logo" src="../../assets/icons/login/DDS_logo.png" />

    <router-outlet></router-outlet>
  </div>
</div>
